module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26.008 6h-4.016V2c0-1.1-.884-2-1.984-2h-12c-1.1 0-2.016.9-2.016 2v4H2.008C.908 6 0 6.9 0 8s-.008 2 1.992 2v20c0 1.1.916 2 2.016 2h20c1.1 0 1.984-.9 1.984-2V10c2 0 2.008-.9 2.008-2s-.892-2-1.992-2zM9.992 4h8v2h-8V4zm2 21a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12zm8 0a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/trash-3.js
// module id = 1457
// module chunks = 14